<template> 
<div>
  <ProductPage :slug="slug"/>
</div>
</template>

<script>
  import { defineComponent, useRoute } from "@nuxtjs/composition-api";
  import ProductPage from '~/pages/solepro/Product/index.vue'
  export default defineComponent({
    layout: 'solepro',
    components : {
      ProductPage
    },
    middleware: [
    'url-resolver',
  ],
    setup() {
      const route = useRoute();
      const slug = route.value.params.slug;

      
      return {
        slug
      };
    },
  });
</script>
  